<mat-dialog-content>
	<p>{{mensaje}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button color="accent" [mat-dialog-close]="cerrarDialogo()" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>